<template>
  <div>
    <NavigationDrawer />
    <br>
    <router-view></router-view>
  </div>
</template>

<script>
import NavigationDrawer from '../views/Navbar';
export default {
  components: {
    NavigationDrawer,
  }
};
</script>
<style>
.footer{
  margin-top:20rem !important; 
}
</style>
